import { render, staticRenderFns } from "./TalentMatricesComponent.vue?vue&type=template&id=10edb2a5&scoped=true"
import script from "./TalentMatricesComponent.vue?vue&type=script&lang=js"
export * from "./TalentMatricesComponent.vue?vue&type=script&lang=js"
import style0 from "./TalentMatricesComponent.vue?vue&type=style&index=0&id=10edb2a5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10edb2a5",
  null
  
)

export default component.exports